export const buildUrl = (url: string, params: any) => {
  let buildedUrl = url;
  const paramsArray = [];

  for (const key in params) {
    paramsArray.push(`${key}=${params[key]}`);
  }

  if (paramsArray.length > 0) {
    buildedUrl += (buildedUrl.indexOf('?') === -1 ? '?' : '&') + paramsArray.join('&');
  }

  return buildedUrl;
};
